export default "__VITE_ASSET__g7sFVY86__"